import httpClient from '../../shared/services/httpClient';
import { UserAccountActivationDTO } from '../../interfaces/UserAccountActivationDTO';
import { UserAccountLoginResponseDto } from '../../interfaces/UserAccountLoginResponseDto';

interface UserCreateData {
  name: string;
  password: string;
  email: string;
  type: string;
  socialNumber: string;
  enterpriseNumber: string;
  phone: string;
}

export const UserCreate = async (data: UserCreateData) => {
  const response = await httpClient.post('/user/create', data, { skipAuth: true });
  return response.data;
};

export const userActivationGet = async (code: string) => {
  const response = await httpClient.get<UserAccountActivationDTO>(`/user/activation?code=${code}`, {
    skipAuth: false,
  });
  return response.data;
};

export const userActivationUpdate = async (data: UserAccountActivationDTO) => {
  try {
    const response = await httpClient.put<UserAccountLoginResponseDto>('/user/activation', data, {
      skipAuth: false,
    });
    return response.data;
  } catch (error: any) {
    if (error?.status === 404 || error?.status === 405) {
      const response = await httpClient.post<UserAccountLoginResponseDto>(
        '/user/activation',
        data,
        {
          skipAuth: false,
        },
      );
      return response.data;
    }
    throw error;
  }
};
